import { render, staticRenderFns } from "./synchronizationList.vue?vue&type=template&id=14b7bf24&scoped=true"
import script from "./synchronizationList.vue?vue&type=script&lang=js"
export * from "./synchronizationList.vue?vue&type=script&lang=js"
import style0 from "./synchronizationList.vue?vue&type=style&index=0&id=14b7bf24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b7bf24",
  null
  
)

export default component.exports